let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fbIIm")).then(() => parcelRequire('a6GY6'));